import { sendPost } from './http.js'
const commons = (url, params, fn) => {
  return sendPost(url, params)
    .then((res) => {
      fn(res)
      //console.log('成功')
    }).catch((err) => {
		throw Error(err)
      fn(err)
      //console.log('失败')
  })
}
const api = {
	'counts':'/user/user/counts',
	'login': '/login/login/index',
	'userInfo': '/user/user/info',
	'editpass': '/login/login/channgpwd',
	'openpublicvisible': '/login/login/openpublicvisible',
	'checkwechat': '/login/login/checkwechat',
	'loginEditinfo': '/login/login/editinfo',
	'plateformActive': '/user/user/plateform/active',
	'depositConfirmAPI': '/user/confirm_agreement' // 用户是否同意保证金协议
}

export default {
	counts(params) {
	    return sendPost(api.counts, params)
	},
	login(params) {
	    return sendPost(api.login, params)
	},
	getUserInfo(params, fn) {
		commons(api.userInfo, params, fn)
	},
	editpass(params, fn) {
		return sendPost(api.editpass, params)
	},
	openpublicvisible(params, fn) {
		commons(api.openpublicvisible, params, fn)
	},
	checkwechat(params) {
		return sendPost(api.checkwechat, params)
	},
	loginEditinfo(params) {
		return sendPost(api.loginEditinfo, params)
	},
	plateformActive(params) {
		return sendPost(api.plateformActive, params)
	},
	depositConfirmAPI(params) {
		return sendPost(api.depositConfirmAPI, params)
	}
}